import { useEffect } from 'react';
import { SITE_CONFIG } from '../config/siteConfig';

/**
 * Simple SEO Component - No external dependencies
 * Uses native DOM manipulation to update meta tags
 */
const SEO = ({
    title,
    description,
    pathname = '/',
    image,
    keywords = [],
}) => {
    const seo = {
        title: title || SITE_CONFIG.title,
        description: description || SITE_CONFIG.description,
        url: `${SITE_CONFIG.url}${pathname}`,
        image: image || SITE_CONFIG.ogImage,
        keywords: [...keywords, SITE_CONFIG.keywords].join(', '),
    };

    useEffect(() => {
        // Update document title
        document.title = seo.title;

        // Helper function to update or create meta tags
        const updateMetaTag = (name, content, isProperty = false) => {
            const attribute = isProperty ? 'property' : 'name';
            let element = document.querySelector(`meta[${attribute}="${name}"]`);

            if (!element) {
                element = document.createElement('meta');
                element.setAttribute(attribute, name);
                document.head.appendChild(element);
            }

            element.setAttribute('content', content);
        };

        // Helper function to update or create link tags
        const updateLinkTag = (rel, href) => {
            let element = document.querySelector(`link[rel="${rel}"]`);

            if (!element) {
                element = document.createElement('link');
                element.setAttribute('rel', rel);
                document.head.appendChild(element);
            }

            element.setAttribute('href', href);
        };

        // Primary Meta Tags
        updateMetaTag('description', seo.description);
        updateMetaTag('keywords', seo.keywords);
        updateMetaTag('author', SITE_CONFIG.author);

        // Canonical URL
        updateLinkTag('canonical', seo.url);

        // Open Graph
        updateMetaTag('og:type', 'website', true);
        updateMetaTag('og:url', seo.url, true);
        updateMetaTag('og:title', seo.title, true);
        updateMetaTag('og:description', seo.description, true);
        updateMetaTag('og:image', seo.image, true);
        updateMetaTag('og:site_name', SITE_CONFIG.name, true);

        // Twitter
        updateMetaTag('twitter:card', 'summary_large_image');
        updateMetaTag('twitter:url', seo.url);
        updateMetaTag('twitter:title', seo.title);
        updateMetaTag('twitter:description', seo.description);
        updateMetaTag('twitter:image', seo.image);

        // Additional SEO
        updateMetaTag('robots', 'index, follow');
        updateMetaTag('language', 'English');
        updateMetaTag('geo.region', 'IN');
        updateMetaTag('geo.placename', 'India');
    }, [seo.title, seo.description, seo.url, seo.image, seo.keywords]);

    return null; // This component doesn't render anything
};

export default SEO;
